import { Lens } from '@dhmk/zustand-lens';

export interface LayoutSlice {
  isSidebarCollapsed: boolean;
  toggleSidebar: () => void;
  resetState: () => void;
}

const initialState = {
  isSidebarCollapsed: false,
} as const;

export const createLayoutStore: Lens<LayoutSlice> = (set) => ({
  ...initialState,
  toggleSidebar: () =>
    set((state) => {
      state.isSidebarCollapsed = !state.isSidebarCollapsed;
    }),
  resetState: () => set(() => initialState),
});
